import {Component, OnInit} from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {MatDialog} from '@angular/material/dialog';
import {NewTaskModalComponent} from '@components/my-web-desk/new-task-modal/new-task-modal.component';
import {OdmoriService} from './odmori.service';
import {ToastrService} from 'ngx-toastr';
import {ConstantsService} from '@app/services/constants/constants.service';
import {BridgeService} from '@app/services/bridge/bridge.service';
import {environment} from '@env/environment';
import {DatePipe} from '@angular/common';
import {MyModalService} from './modal/modal.service';
import {Globals} from '@app/services/globals.service';

export interface Track {
    title: string;
    id: string;
    request: any[];
}

@Component({
    selector: 'app-odmori',
    templateUrl: './odmori.component.html',
    styleUrls: ['./odmori.component.css']
})

export class OdmoriComponent implements OnInit {

    isLoading: boolean;
    holidays: any;
    showDashboard: boolean = false;
    userId: number;
    cliUrl = environment.cliURL;
    user: any;
    creatorId: number;

    permissionArray: any;
    
    public tracks: Track[] = [
        {
            title: 'U toku',
            id: 'pending',
            request: []
        },
        {
            title: 'Odobrio menadzer',
            id: 'manager_approved',
            request: []
        },
        {
            title: 'Odobrio izvrsni direktor',
            id: 'director_approved',
            request: []
        }
    ];

    statusMapping = {
        pending: 'U toku',
        manager_approved: 'Odobrio menadžer',
        director_approved: 'Odobrio izvršni direktor',
        manager_reject: 'Odbio menadžer',
        director_reject: 'Odbio izvršni direktor',
        employee_reject: 'ZAHTJEV ZA PONIŠTENJE ODMORA',
        manager_approved_reject: 'Menadžer odobrio poništenje zahtjeva'
    };

    constructor(public matDialog: MatDialog, public odmoriService: OdmoriService, public toastr: ToastrService, 
        public constants: ConstantsService, private bridge: BridgeService, private datePipe: DatePipe,
        private myModalService: MyModalService, public globals: Globals,) {}

    ngOnInit(): void {
        this.userId = +this.constants.creator_id;
        this.isLoading = true;

        this.creatorId = this.constants.getLoggedInUserId();

        this.permissionArray = this.globals.getPermittedUsers();

        this.getHolidayData();
    };

    createNewHolidayRequest() {
        const dialogRef = this.matDialog.open(NewTaskModalComponent, {
            disableClose: true,
            height: '600px',
            width: '800px',
            data: {
                mode: 'new',
                task: null,
                sort: 'task',
                module: 'holidays'
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getHolidayData();
            };
        });
    };

    get trackIds(): string[] {
        return this.tracks.map(track => track.id);
    }

    getHolidayData() {
        this.showDashboard = false;

        let pending = [];
        let manager_approved = [];
        let director_approved = [];

        this.odmoriService.getHolidayData().subscribe(result => {
            this.isLoading = false;

            if (result.type === 'success') {
                this.holidays = result.data;
                
                Object.keys(this.holidays).forEach(key => {
                    const status = this.holidays[key]['status'];
                    const userID = this.holidays[key]['user_id'];
                    this.holidays[key]['statusBadge'] = this.statusMapping[status] || '';
                    this.holidays[key]['fullName'] = this.user = this.globals.getAllUsers().find(value => userID == value.id);
                });


                Object.keys(this.holidays).forEach(key => {
                    if (['pending', 'employee_reject', 'manager_reject', 'director_reject'].includes(this.holidays[key]['status'])) {
                        pending.push(this.holidays[key]);
                    } else if (this.holidays[key]['status'] === 'manager_approved' || this.holidays[key]['status'] === 'manager_approved_reject') {
                        manager_approved.push(this.holidays[key]);
                    } else if (this.holidays[key]['status'] === 'director_approved') {
                        director_approved.push(this.holidays[key]);
                    }
                });

                this.showDashboard = true;

                this.tracks[0]['request'] = pending;
                this.tracks[1]['request'] = manager_approved;
                this.tracks[2]['request'] = director_approved;

                return;
            };

            this.toastr.error('Došlo je do greške prilikom vraćanja podataka. Molimo vas da se obratite korisničkoj podršci.');
        });
    };

    drop(event: CdkDragDrop<string[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
        }
    }

    onTalkDrop(event: CdkDragDrop<any[]>) {
        const new_status = event.container.id;

        const request = event.previousContainer.data[event.previousIndex];
        const requestCopy =  JSON.parse(JSON.stringify(request));

        request['status'] = new_status;

        if(new_status === 'manager_approved') {
            request['statusBadge'] = 'Odobrio menadžer';
        }

        if(new_status === 'director_approved') {
            request['statusBadge'] = 'Odobrio izvršni direkotor';
        }

        if(new_status === 'pending') {
            request['statusBadge'] = 'U toku';
        }

        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            this.changeStatusOfRequest(request, new_status, requestCopy['status']);

            transferArrayItem(
              event.previousContainer.data,
              event.container.data,
              event.previousIndex,
              event.currentIndex
            );
        };
    };

    changeStatusOfRequest(request, new_status, requestCopyStatus) {
        if(requestCopyStatus === 'employee_reject' && new_status === 'manager_approved') {
            new_status = 'manager_approved_reject'
        };

        let requestData = {
            '_id': request['_id']
        }

        this.odmoriService.changeStatusOfRequest(requestData, new_status, requestCopyStatus).subscribe(response => {
            if (response.type == 'success') {
                const dateFrom = new Date(request.date_from);
                const dateTo = new Date(request.date_to);

                this.user = this.globals.getAllUsers().find(value => this.creatorId === value.id);
                console.log(this.user);
                var option = ' odmor/slobodan dan ';

                if((requestCopyStatus === 'employee_reject' || requestCopyStatus === 'manager_approved_reject') 
                    && (new_status === 'manager_approved' || new_status === 'director_approved')) {
                        option = ' poništenje odmora/slobodnog dana ';
                };

                var description = 'Menadžer i izvršni direktor su vam odobrili' + option + 'u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '.';
                
                if(new_status === 'manager_approved') {
                    description = 'Menadžer vam je odobrio' + option + 'u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '. Molimo vas sačekajte odobrenje izvršnog direktora.';

                    var descriptionForDirector = 'Menadžer je odobrio' + option + this.user.first_name + ' ' + this.user.last_name  + ' u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '. Molimo vas validirajte zahtjev.';
                    var titleForDirector = 'Menadžer je odobrio' + option + this.user.first_name + ' ' + this.user.last_name  + ' u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy') + '.';
                    
                    this.sendNotification(titleForDirector, descriptionForDirector, [1, 14], request._id);
                };

                var title = 'Status odmora u periodu od ' + this.datePipe.transform(dateFrom, 'dd-MM-yyyy') + ' do ' + this.datePipe.transform(dateTo, 'dd-MM-yyyy'); 

                this.sendNotification(title, description, [+request.user_id], request._id);
                
                return;
            };

            this.toastr.error('Došlo je do greške prilikom vraćanja podataka. Molimo vas da se obratite korisničkoj podršci.');
        });
    };

    sendNotification(title, description, employee, reqId) {
        let link = this.cliUrl + '/zahtjev-pregled/' + reqId;

        const notif = {
            notification: {
                title: title,
                description: description,
                employers: employee,
                type: 'informacija',
                link: link
            }
        };
        
        this.bridge.sendDataViaBridge(notif);
    };

    showUsedDays() {
        this.myModalService.openModalUsedDays(); 
    };

}